export default __webpack_public_path__ + "a83756aa488bd1a5e4a50bc3bdb4b1ea.png";